import { css } from '@emotion/react';

export const mainContainer = css`
    display: flex;
    gap: 12px;
    width: 100%;
    height: 200px;
    overflow: hidden;
`;

export const col = css`
    display: flex;
    flex: 1;
    flex-direction: column;

    &:last-child {
        border-right: none;
    }
`;

export const divider = css`
    width: 1px;
    height: 100%;
    background: #e9ecef;
`;

export const header = css`
    display: flex;
    height: 24px;
    align-items: center;
    padding: 0 10px;
    background: rgb(156, 157, 161);
    color: white;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.3px;
    border-radius: 4px;
`;

export const content = css`
    flex: 1;
    padding: 4px;
    overflow-y: auto;
    background-color: #f8f9fa;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }
`;

export const tipText = css`
    font-size: 11px;
    color: #6c757d;
    margin-top: 4px;
`;
